module.exports = __webpack_public_path__ + "media/images/emblems/Sorengo-coat_of_arms-c86fe941c415458a21d302aa3824565c.svg";